import { render, staticRenderFns } from "./ProjectProposalNew.vue?vue&type=template&id=c08f7d5a&"
import script from "./ProjectProposalNew.vue?vue&type=script&lang=ts&"
export * from "./ProjectProposalNew.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectProposalNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports